import { compileQuery, isCompiledQuery } from 'graphql-jit';
import { ValueOrPromise } from 'value-or-promise';
import { getDocumentString, makeExecute, makeSubscribe } from '@envelop/core';
export const useGraphQlJit = (compilerOptions = {}, pluginOptions = {}) => {
    const jitCacheByDocumentString = pluginOptions.cache;
    const jitCacheByDocument = new WeakMap();
    function getCacheEntry(args) {
        let cacheEntry;
        cacheEntry = jitCacheByDocument.get(args.document);
        if (!cacheEntry && jitCacheByDocumentString) {
            const documentSource = getDocumentString(args.document);
            if (documentSource) {
                cacheEntry = jitCacheByDocumentString.get(documentSource);
            }
        }
        if (!cacheEntry) {
            const compilationResult = compileQuery(args.schema, args.document, args.operationName ?? undefined, compilerOptions);
            if (!isCompiledQuery(compilationResult)) {
                if (pluginOptions?.onError) {
                    pluginOptions.onError(compilationResult);
                }
                else {
                    console.error(compilationResult);
                }
                cacheEntry = {
                    query: () => compilationResult,
                    stringify: r => JSON.stringify(r),
                };
            }
            else {
                cacheEntry = compilationResult;
            }
            jitCacheByDocument.set(args.document, cacheEntry);
            if (jitCacheByDocumentString) {
                const documentSource = getDocumentString(args.document);
                if (documentSource) {
                    jitCacheByDocumentString.set(documentSource, cacheEntry);
                }
            }
        }
        return cacheEntry;
    }
    function jitExecutor(args) {
        const cacheEntry = getCacheEntry(args);
        const executeFn = cacheEntry.subscribe ? cacheEntry.subscribe : cacheEntry.query;
        return new ValueOrPromise(() => executeFn(args.rootValue, args.contextValue, args.variableValues))
            .then(result => {
            result.stringify = cacheEntry.stringify;
            return result;
        })
            .resolve();
    }
    const executeFn = makeExecute(jitExecutor);
    const subscribeFn = makeSubscribe(jitExecutor);
    const enableIfFn = pluginOptions.enableIf;
    return {
        onExecute({ args, setExecuteFn }) {
            if (enableIfFn) {
                return new ValueOrPromise(() => enableIfFn(args))
                    .then(enableIfRes => {
                    if (enableIfRes) {
                        setExecuteFn(executeFn);
                    }
                })
                    .resolve();
            }
            setExecuteFn(executeFn);
        },
        onSubscribe({ args, setSubscribeFn }) {
            if (enableIfFn) {
                return new ValueOrPromise(() => enableIfFn(args))
                    .then(enableIfRes => {
                    if (enableIfRes) {
                        setSubscribeFn(subscribeFn);
                    }
                })
                    .resolve();
            }
            setSubscribeFn(subscribeFn);
        },
    };
};
